import { getTranspiledPipelinesData } from '../../data/apis/api';
import { useRestQuery } from '../../data/util';
import { QueryKey } from './config';

export const usePipelinesData = (transpilerId: string, isBulk?: boolean, disabled?: boolean) => {
  const data = useRestQuery(
    [QueryKey, 'getPipelinesTranspiledData', transpilerId],
    () => getTranspiledPipelinesData(transpilerId, isBulk),
    {
      retry: false,
      refetchOnMount: true,
      enabled: !!transpilerId && !disabled,
      sentryTag: 'transpiler.getPipelinesTranspiledData'
    }
  );

  return data;
};
